<template>
  <div class="p-4 mx-auto">
    <table class="w-full">
      <tr>
        <th class=" text-left py-2 px-1">Title</th>
        <th class=" text-left py-2 px-1">Course</th>
        <th class=" text-left py-2 px-1">Instructor</th>
        <th class=" text-left py-2 px-1">Date</th>
        <th class=" text-left py-2 px-1">Time</th>
        <th class=" text-left py-2 px-1">Action</th>
      </tr>
      <tr
        v-for="(webinar, index) in webinars"
        :key="index"
        :class="index % 2 == 0 ? 'bg-gray-100' : ''"
      >
        <td class="border px-8 py-4">
          {{ webinar.topic }}
        </td>
        <td class="border px-8 py-4">{{ webinar.course }}</td>
        <td class="border px-8 py-4">{{ webinar.instructor }}</td>
        <td class="border px-8 py-4 capitalize">
          {{ webinar.start_time | dateFilter }}
        </td>
        <td class="border px-8 py-4">{{ webinar.start_time | timeFilter }}</td>
        <td class="border px-8 py-4">
          <lms-blue-button @click="navigate(webinar.id)"
            >View Admin</lms-blue-button
          >
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["search"],
  components: {
    LmsBlueButton: () => import("@/components/general/button"),
  },
  data() {
    return {
      webinars: [],
    };
  },
  computed: {
    ...mapGetters(["getAdmins"]),
  },
  async created() {
    this.webinars = await this.getWebinars();
  },
  methods: {
    ...mapActions(["getWebinars"]),
    navigate(id) {
      this.$router.push({ name: "admin-user", params: { id: id } });
    },
  },
};
</script>

<style lang="scss" scoped></style>
